/* eslint-disable no-useless-catch */
import axios from 'axios';
import RoutePaths from '../config/Routes';
import { getCurrentTimestamp } from './Datetime';
import { getAPIBaseUrl } from './AppDomain';

export const postApiCall = async (endpoint, data) => {
  const baseAPIUrl = getAPIBaseUrl();
  const options = {
    url: `${baseAPIUrl}${endpoint}`,
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Req-Time': getCurrentTimestamp(),
      'Access-Control-Allow-Origin': '*',
    },
    withCredentials: true,
    data: data || {},
  };

  try {
    const response = await axios(options);
    return response;
  } catch (e) {
    if (e.response.status === 401) {
      window.location.assign(RoutePaths.LOGOUT);
    }
    throw e;
  }
};

export const getApiCall = async (endpoint) => {
  const baseAPIUrl = getAPIBaseUrl();
  const options = {
    url: `${baseAPIUrl}${endpoint}`,
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Req-Time': getCurrentTimestamp(),
      'Access-Control-Allow-Origin': '*',
    },
    withCredentials: true,
    data: {},
  };

  try {
    const response = await axios(options);
    return response;
  } catch (e) {
    if (e.response.status === 401) {
      window.location.assign(RoutePaths.LOGOUT);
    }
    throw e;
  }
};

export const deleteApiCall = async (endpoint) => {
  const baseAPIUrl = getAPIBaseUrl();
  const options = {
    url: `${baseAPIUrl}${endpoint}`,
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Req-Time': getCurrentTimestamp(),
      'Access-Control-Allow-Origin': '*',
    },
    withCredentials: true,
    data: {},
  };

  try {
    const response = await axios(options);
    return response;
  } catch (e) {
    if (e.response.status === 401) {
      window.location.assign(RoutePaths.LOGOUT);
    }
    throw e;
  }
};
